(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-buybox-ctas"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-om-buybox-ctas]');
    if (!roots.length) return;

    const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    roots.forEach((root) => {
      const buyNowBtn = root.querySelector('[data-om-buy-now]');
      const buyNowFeedback = root.querySelector('[data-om-buy-now-feedback]');
      const enquiry = root.querySelector('[data-om-enquiry]');
      const form = root.querySelector('.om-enquiry__form');
      const titleEl = root.querySelector('[data-om-enquiry-title]');
      const typeInput = root.querySelector('[data-om-enquiry-type]');
      const successEl = root.querySelector('[data-om-enquiry-success]');
      const variantsEl = root.querySelector('[data-om-enquiry-variants]');
      let variants = [];
      try {
        variants = variantsEl ? JSON.parse(variantsEl.textContent || '[]') : [];
      } catch (e) {
        variants = [];
      }

      const buybox = root.closest('.product-buybox') || root.closest('.shopify-section');
      const productForm = buybox && buybox.querySelector('product-form-component form, form[action*="/cart/add"]');

      const getVariantId = () => {
        const input = productForm && productForm.querySelector('input[name="id"], select[name="id"]');
        return input ? input.value : null;
      };

      const getQuantity = () => {
        const input =
          (productForm && productForm.querySelector('input[name="quantity"]')) ||
          (buybox && buybox.querySelector('quantity-selector-component input[name="quantity"], .quantity-selector input[type="number"]'));
        const qty = input ? Number(input.value) : 1;
        return Number.isFinite(qty) && qty > 0 ? qty : 1;
      };

      const showFeedback = (el, message) => {
        if (!el) return;
        if (!message) {
          el.hidden = true;
          el.textContent = '';
          return;
        }
        el.hidden = false;
        el.textContent = message;
      };

      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', async () => {
          if (buyNowBtn.disabled) return;
          const variantId = getVariantId();
          if (!variantId) {
            showFeedback(buyNowFeedback, 'Unable to add this product right now.');
            return;
          }
          buyNowBtn.dataset.loading = 'true';
          buyNowBtn.disabled = true;
          showFeedback(buyNowFeedback, '');
          try {
            const response = await fetch(`${routesRoot}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity: getQuantity() }] }),
            });
            if (!response.ok) {
              const data = await response.json().catch(() => ({}));
              throw new Error(data.description || data.message || 'Could not add to cart');
            }
            window.location.href = `${routesRoot}checkout`;
          } catch (err) {
            showFeedback(buyNowFeedback, err.message || 'Could not proceed to checkout');
            buyNowBtn.disabled = false;
            delete buyNowBtn.dataset.loading;
          }
        });
      }

      let enquiryScrollY = 0;

      // Portal panel to body so sticky buybox / overflow ancestors cannot clip it.
      if (enquiry && enquiry.parentElement !== document.body) {
        document.body.appendChild(enquiry);
      }

      const setEnquiryOpen = (open, mode) => {
        if (!enquiry) return;
        enquiry.classList.toggle('is-open', open);
        enquiry.setAttribute('aria-hidden', String(!open));
        document.body.classList.toggle('om-enquiry-open', open);
        if (open) {
          enquiryScrollY = window.scrollY;
          document.body.style.width = '100%';
          document.body.style.position = 'fixed';
          document.body.style.top = `-${enquiryScrollY}px`;
          document.body.style.left = '0';
          enquiry.classList.toggle('is-bulk', mode === 'bulk');
          if (titleEl) {
            titleEl.textContent =
              mode === 'bulk'
                ? titleEl.dataset.titleBulk || titleEl.textContent
                : titleEl.dataset.titleQuote || titleEl.textContent;
          }
          if (typeInput) {
            typeInput.value =
              mode === 'bulk'
                ? titleEl?.dataset.titleBulk || 'Bulk Pricing'
                : titleEl?.dataset.titleQuote || 'Request Quote';
          }
          if (successEl) successEl.hidden = true;
          if (form) form.hidden = false;
          requestAnimationFrame(() => {
            enquiry.querySelector('[data-om-enquiry-close]')?.focus({ preventScroll: true });
          });
        } else {
          document.body.style.width = '';
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          window.scrollTo({ top: enquiryScrollY, behavior: 'instant' });
          enquiry.classList.remove('is-bulk');
        }
      };

      root.querySelectorAll('[data-om-enquiry-open]').forEach((btn) => {
        btn.addEventListener('click', () => setEnquiryOpen(true, btn.getAttribute('data-om-enquiry-open')));
      });
      enquiry?.querySelector('[data-om-enquiry-close]')?.addEventListener('click', () => setEnquiryOpen(false));
      enquiry?.querySelector('[data-om-enquiry-overlay]')?.addEventListener('click', () => setEnquiryOpen(false));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && enquiry?.classList.contains('is-open')) setEnquiryOpen(false);
      });

      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const submitBtn = form.querySelector('[type="submit"]');
          if (submitBtn) submitBtn.disabled = true;
          try {
            const body = new FormData(form);
            const response = await fetch(form.action || `${routesRoot}contact`, {
              method: 'POST',
              body,
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) throw new Error('Submit failed');
            form.hidden = true;
            if (successEl) successEl.hidden = false;
          } catch (err) {
            showFeedback(buyNowFeedback, 'Could not send enquiry. Please try again.');
          } finally {
            if (submitBtn) submitBtn.disabled = false;
          }
        });
      }

      // Keep Buy Now + enquiry fields in sync with variant changes
      const section = root.closest('.shopify-section');
      section?.addEventListener('variant:update', (event) => {
        const resource = event.detail?.resource;
        if (!resource) return;
        if (buyNowBtn) {
          const available = Boolean(resource.available);
          buyNowBtn.disabled = !available;
          buyNowBtn.setAttribute('aria-disabled', String(!available));
          const labelEl =
            buyNowBtn.querySelector('[data-om-buy-now-label]') || buyNowBtn.querySelector('.button__label');
          const nextLabel = available
            ? buyNowBtn.dataset.labelBuy || 'Buy Now'
            : buyNowBtn.dataset.labelSoldOut || 'Sold out';
          if (labelEl) {
            labelEl.textContent = nextLabel;
          }
        }
        const match = variants.find((v) => String(v.id) === String(resource.id));
        /* Enquiry is portaled to body — query from the panel, not the buybox root */
        const skuInput = enquiry?.querySelector('[data-om-enquiry-sku]');
        const variantInput = enquiry?.querySelector('[data-om-enquiry-variant]');
        const urlInput = enquiry?.querySelector('[data-om-enquiry-url]');
        if (skuInput) skuInput.value = match?.sku || resource.sku || '';
        if (variantInput) variantInput.value = match?.title || resource.title || '';
        if (urlInput) {
          const base = urlInput.dataset.base || '';
          urlInput.value = `${base}?variant=${resource.id}`;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-support"] && !Shopify.designMode) return;
  try {
    (() => {
    const markContactLayouts = () => {
      document.querySelectorAll('.layout-panel-flex--row').forEach((row) => {
        const hasSupport = Boolean(row.querySelector('.contact-support'));
        const hasForm = Boolean(row.querySelector('.contact-form'));
        row.classList.toggle('om-contact-layout', hasSupport && hasForm);
      });
    };
    markContactLayouts();
    document.addEventListener('shopify:section:load', markContactLayouts);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["homepage-hero"] && !Shopify.designMode) return;
  try {
    (() => {
    class OmHeroCarouselShared extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-hero-track]');
        this.slides = this.querySelectorAll('.om-homepage-hero-carousel__slide');
        this.prevButton = this.querySelector('[data-hero-prev]');
        this.nextButton = this.querySelector('[data-hero-next]');
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.index = 0;
        this.pointerStartX = null;
        this.pointerDeltaX = 0;
        this.swiping = false;

        if (!this.track || this.slides.length <= 1) return;

        this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.heroDot)));
        });

        this.addEventListener('pointerdown', this.#onPointerDown);
        this.addEventListener('pointermove', this.#onPointerMove);
        this.addEventListener('pointerup', this.#onPointerUp);
        this.addEventListener('pointercancel', this.#onPointerUp);
        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('pointerdown', this.#onPointerDown);
        this.removeEventListener('pointermove', this.#onPointerMove);
        this.removeEventListener('pointerup', this.#onPointerUp);
        this.removeEventListener('pointercancel', this.#onPointerUp);
      }

      #onPointerDown = (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('a, button, input, textarea, select, label')) return;
        this.pointerStartX = event.clientX;
        this.pointerDeltaX = 0;
        this.swiping = true;
        this.setPointerCapture?.(event.pointerId);
      };

      #onPointerMove = (event) => {
        if (!this.swiping || this.pointerStartX == null) return;
        this.pointerDeltaX = event.clientX - this.pointerStartX;
      };

      #onPointerUp = () => {
        if (!this.swiping) return;
        const threshold = Math.min(80, this.clientWidth * 0.18);
        if (this.pointerDeltaX > threshold) this.goTo(this.index - 1);
        else if (this.pointerDeltaX < -threshold) this.goTo(this.index + 1);
        this.swiping = false;
        this.pointerStartX = null;
        this.pointerDeltaX = 0;
      };

      goTo(nextIndex) {
        const max = this.slides.length - 1;
        if (nextIndex < 0) nextIndex = max;
        if (nextIndex > max) nextIndex = 0;
        this.index = nextIndex;
        this.update();
      }

      update() {
        this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
        this.dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === this.index));
      }
    }

    if (!customElements.get('hero-carousel-shared')) {
      customElements.define('hero-carousel-shared', OmHeroCarouselShared);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
